import ResearchTable from './researchTable'
export default ResearchTable
